<template>
	<div>
		<div v-if="step === 'SEARCH_WINERY'">
			<b-row>
        <b-col>
					<h5>{{ $t('winelist.addWineModal.searchWinery') }}</h5>
					<div class="spacer m"></div>
				</b-col>
			</b-row>
			<SearchWinery ref="searchWinery" @foundWineries="handleFoundWineries" @hasTypedSearchText="handleHasTypedSearchText" />
		</div>
		
		<div v-if="step === 'CHOOSE_WINERY'">
			<ChooseWineryFilter />
			<div class="spacer m"></div>
			<ChooseWinery ref="chooseWinery" :wineries="wineries" :preselectedWinery="preselectedWinery" @winerySelected="handleWinerySelected" />
		</div>
		
		<b-alert :variant="alertType" :show="alertIsVisible">
			{{ alertMessage }}
		</b-alert>

		<div class="step-footer">
			<b-button v-if="cancelButtonVisible" class="cancel" @click="cancel()">
				{{ $t('general.buttons.cancel') }}
			</b-button>
			<b-button v-if="backButtonVisible" class="back" @click="backClick()">
				{{ $t('general.buttons.back') }}
			</b-button>
			<b-button :disabled="okBtnDisabled" variant="success" @click="okClick()">
				{{ this.$t('winelist.addWineModal.chooseWinery') }}
			</b-button>
		</div>
	</div>
</template>

<script>

import SearchWinery from '@/components/modals/addWine/step1/SearchWinery.vue'
import ChooseWinery from '@/components/modals/addWine/step1/ChooseWinery.vue'
import ChooseWineryFilter from '@/components/modals/addWine/step1/ChooseWineryFilter.vue'

const STEP_SEARCH_WINERY = 'SEARCH_WINERY'
const STEP_CHOOSE_WINERY = 'CHOOSE_WINERY'

export default {
	name: 'Step1',
	props: {
		preselectedWinery: {
			type: Object,
			default: () => ({})
		}
	},
	mounted() {
    this.$root.$on('showCreateWinesStep1Alert', (alert) => {
      this.handleShowAlert(alert)
    })
		this.$root.$on('hideCreateWinesStep1Alert', () => {
			this.handleHideAlert()
		})
  },
	data() {
		return {
			wineries: [],
			backButtonVisible: false,
			cancelButtonVisible: true,
			wineriesPresent: false,
			okBtnDisabled: true,
			selectedWinery: {},
			step: STEP_SEARCH_WINERY,
			lastSearchText: '',
			alertType: 'success',
			alertIsVisible: false,
			alertMessage: ''
		}
	},
	components: {
		SearchWinery,
		ChooseWinery,
		ChooseWineryFilter,
	},
	methods: {
		handleFoundWineries(wineries) {
			this.wineries = wineries
			this.okBtnDisabled = true
			this.backButtonVisible = true
			this.cancelButtonVisible = false
			this.step = STEP_CHOOSE_WINERY

			// If the search returned no wineries, show an alert and prefill
			// the AddWineryRow so the user can create the winery directly.
			if (wineries.length === 0) {
				this.$root.$emit('showCreateWinesStep1Alert', {
					message: this.$t('winelist.addWineModal.wineryNotFound'),
					type: 'warning',
				})
				this.$nextTick(() => {
					if (this.$refs.chooseWinery != null) {
						this.$refs.chooseWinery.prefillAddWineryRow(this.lastSearchText)
					}
				})
			}
		},
		/**
		 * Search for a winery by title. Used to pre-fill step 1 when the
		 * wine's winery does not match the sheet row's producer.
		 *
		 * @param {string} producer The producer name to search for
		 */
		searchForWinery(producer) {
			if (producer == null || producer === '') {
				return
			}
			this.lastSearchText = producer
			this.resetAlert()
			this.step = STEP_SEARCH_WINERY
			this.$nextTick(() => {
				if (this.$refs.searchWinery != null) {
					this.$refs.searchWinery.searchFor(producer)
				}
			})
		},
		handleWinerySelected(selectedWinery) {
			this.selectedWinery = selectedWinery
			this.okBtnDisabled = this.noWinerySelected()
		},
		handleHasTypedSearchText(hasTyped) {
			this.okBtnDisabled = !hasTyped
		},
		handleShowAlert(alert) {
			this.alertMessage = alert.message
			this.alertType = alert.type
			this.alertIsVisible = true
		},
		handleHideAlert() {
			this.resetAlert()
		},
		resetAlert() {
			this.alertMessage = ''
			this.alertType = 'success'
			this.alertIsVisible = false
		},
		noWinerySelected() {
			return Object.keys(this.selectedWinery).length === 0
		},
		backClick() {
			this.resetAlert()
			this.okBtnDisabled = true
			this.selectedWinery = {}
			this.wineries = []
			this.step = STEP_SEARCH_WINERY
			this.backButtonVisible = false
			this.cancelButtonVisible = true
		},
		/**
		 * When the modal goes back from step 2 to step 1, the winery that was
		 * already selected should be visible again. This is triggered by the
		 * preselectedWinery prop changing.
		 */
		showPreselectedWinery() {
			const winery = this.preselectedWinery
			if (winery == null || Object.keys(winery).length === 0) {
				return
			}
			this.selectedWinery = winery
			this.wineries = [winery]
			this.okBtnDisabled = false
			this.backButtonVisible = true
			this.cancelButtonVisible = false
			this.step = STEP_CHOOSE_WINERY
		},
		/**
		 * Start loading wineries from search text or
		 * send event to CreateWinesModal when winery is selected
		 */
		okClick() {
			this.resetAlert()
			if (this.step === STEP_SEARCH_WINERY) {
				this.$refs.searchWinery.loadWineries()
			} else if (this.step === STEP_CHOOSE_WINERY) {
				this.$emit('okFromStep1', this.selectedWinery)
			}
		},
		cancel() {
			this.resetAlert()
			this.$emit('cancel')
		},
	},
	computed: {
		winerySelected() {
			return Object.keys(this.selectedWinery).length > 0
		}
	},
	watch: {
		preselectedWinery: {
			handler() {
				this.showPreselectedWinery()
			},
			immediate: true
		}
	}
}

</script>